export const web = {
  id: 'web',
  label: 'Web / PWA',
  emoji: '🌐',
  colorScheme: 'teal',
  description: 'Favicons & PWA manifest icons',
  folder: 'web',
  icons: [
    { filename: 'favicon-16x16.png',    size: 16,  folder: 'web', label: 'Favicon 16×16' },
    { filename: 'favicon-32x32.png',    size: 32,  folder: 'web', label: 'Favicon 32×32' },
    { filename: 'favicon-48x48.png',    size: 48,  folder: 'web', label: 'Favicon 48×48' },
    { filename: 'apple-touch-icon.png', size: 180, folder: 'web', label: 'Apple Touch Icon (180×180)' },
    { filename: 'icon-192x192.png',     size: 192, folder: 'web', label: 'PWA Icon 192×192' },
    { filename: 'icon-512x512.png',     size: 512, folder: 'web', label: 'PWA Icon 512×512' },
  ],
  extraFiles: [
    {
      filename: 'site.webmanifest',
      folder: 'web',
      generate: (appName = 'App') =>
        JSON.stringify(
          {
            name: appName,
            short_name: appName,
            icons: [
              { src: 'icon-192x192.png', sizes: '192x192', type: 'image/png' },
              { src: 'icon-512x512.png', sizes: '512x512', type: 'image/png' },
            ],
            theme_color: '#ffffff',
            background_color: '#ffffff',
            display: 'standalone',
          },
          null,
          2
        ),
    },
    {
      filename: 'favicon-snippet.html',
      folder: 'web',
      generate: () =>
        `<!-- Paste inside <head> -->
<link rel="icon" type="image/x-icon" href="/favicon.ico">
<link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png">
<link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png">
<link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png">
<link rel="manifest" href="/site.webmanifest">
`,
    },
  ],
};
